import {useEffect, useState} from 'react';  
import OECloseIcon from '../assets/images/Illustrations/OE-Close.svg';
import ExitIcon from '../assets/images/Illustrations/Exit.svg';
import Cookies from 'js-cookie';
import { Button } from 'react-bootstrap';
import { getApiService } from '../services/ApiService';
import { GetPayLoad } from '../services/PayLoadStorage';
import parse from 'html-react-parser';
import { getCookieOptions } from '../utils/cookieUtils';

const MarketExitModal = ({ onClose }) => {
    
    const Payload = GetPayLoad('PayLoad');
    const [marketExitContent, setMarketExitContent] = useState([]);
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const headers = {
            "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
            "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
            "X-Hps-Region": Payload?.region,
            "X-Hps-Carrier": Payload?.owning_carrier
        };
    const lang = Cookies.get('lang') || 'eng';
    const siteCd = Payload?.site_cd || '';
    const [showContent, setShowContent] = useState(false); 

    useEffect(() => {
        if(siteCd !== '') {
            const page = 'marketexit'; 
            const targetUrl = process.env.REACT_APP_API_CMS_CONTENT_ENDPOINT;            
            getApiService(
                baseUrl,
                targetUrl,
                {
                    page: page,
                    site_cd: siteCd,
                    lang: lang
                },
                headers
            )
            .then((response) => {
                if(response?.data && response.data.status === 'SUCCESS'){
                    const result = response.data.data;
                    setMarketExitContent(result?.marketexit);
                    setShowContent(true);
                }
            })
            .catch((error) =>{
                console.log(error);
            })
        }
    }, [lang]);

    // Logic for reminding later
    const handleRemindMeLater = () => {
        let date = new Date();
        date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
        Cookies.set('showMarketPopup', 'true', { expires: date, ...getCookieOptions() });
        onClose(); //Close the modal
    }
    // Logic for not reminding again
    const handleDontRemindMeAgain = () => {
        let date = new Date();
        date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
        Cookies.set('showMarketPopup', 'false', { expires: date, ...getCookieOptions() });
        onClose(); //Close the modal
    }
    
    return (
        <div>
            {
                showContent && 
                <div class="OE-Content px-4 py-4 text-center position-relative">
                    <img src = {OECloseIcon} onClick={() => onClose()} class="position-absolute" id="close" style={{cursor: 'pointer'}} alt='Close icon' />
                    <img src = {ExitIcon} width="79" height="79" style={{padding: '12px'}} alt='Exit icon' />
                    {parse(marketExitContent?.marketexit_modal_popup_content || '')}
                </div>
            }
        </div>
    );
};

export default MarketExitModal;